/* Tice Nits: reviewscore telt bij het in beeld komen op naar de ingestelde score; tot dan staat de echte score er. Zonder JS of bij reduced motion staat de score er meteen. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function run(el) {
    const target = el.getAttribute('data-tn-count') || '';
    const m = target.match(/^(\d+)[,.](\d)$/);
    if (!m || reduce || !('IntersectionObserver' in window)) return;
    const whole = m[1];
    const end = parseInt(m[2], 10);
    const sep = target.includes(',') ? ',' : '.';
    const start = 0;
    // de echte score blijft in de HTML staan (Google, schermlezers, snel scrollen); het optellen start pas in beeld (23 okt 2026)
    const io = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      el.textContent = whole + sep + start;
      const t0 = performance.now();
      const tick = (t) => {
        const p = Math.min(1, (t - t0) / 800);
        el.textContent = whole + sep + Math.round(start + (end - start) * p);
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }, { threshold: 0.4 });
    io.observe(el);
  }
  const boot = () => document.querySelectorAll('[data-tn-count]').forEach(run);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
